export default __webpack_public_path__ + "static/ak-cached/24h/media/200visacard.02dc4721.png";